import type { SVGProps } from 'react';
export const Loader = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M6.11 4.18A7 7 0 0 1 10 3a.87.87 0 1 1 0 1.75A5.25 5.25 0 1 0 15.25 10 .88.88 0 0 1 17 10 7 7 0 1 1 6.11 4.18"
      clipRule="evenodd"
    />
    <path
      fill="#E5E5E5"
      fillRule="evenodd"
      d="M13.9 6.1c-.85-.84-2.14-1.35-3.9-1.35V3c2.1 0 3.88.62 5.13 1.87S17 7.9 17 10h-1.75c0-1.76-.51-3.05-1.36-3.9"
      clipRule="evenodd"
    />
  </svg>
);
